import type { State } from '../reducers';

export const selectParcelsData = (state: State) => state.searchParcels.data;
